<template>
  <div>
    <table-widget :items="items" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage" :filter.sync="filter">
      <template slot="content">
        <b-table striped
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              @filtered="onFiltered"
              show-empty
              small>
          <template v-slot:cell(title)="data">
        <router-link :to="{ name: 'translationalTeam', params: { id: data.item.id } }">{{data.item.title}}</router-link>
      </template>
        <template v-slot:cell(name)="data">
          <a :href="translationalTeamUrl + data.item.translationalTeamId" target="_blank">{{ data.item.name }}</a>
        </template>
        <!--- other columns here --->
        <template v-slot:cell(details)="data">
          <a :href="translationalTeamUrl + data.item.translationalTeamId" target="_blank">Details</a>
        </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import * as _ from "lodash";
import TableWidget from "../table-widget";
import AutocompleteFormWrapper from "../autocomplete-form-wrapper";

export default {
  data() {
    return {
      form: {
        items: []
      },
      fields: [   // these are col. headings
        { key: "name", sortable: true },
        //  { key: "details", sortable: false}
        { key: "startDate", label: "Start Date", sortable: true},
        { key: "endDate", sortable: true},
        { key: "details", sortable: false}
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      showForm: false
    };
  },

  props: {
    items: {
      type: Array,
      required: false // Marina: changed to 'false' for debugging
    }
  },

  components: {
    "table-widget": TableWidget,
    // "autocomplete-form": AutocompleteFormWrapper
  },
  computed: {
    translationalTeamUrl: function() {
      if(process.env.NODE_ENV === "production") {
        return "https://translationalteams.chs.asu.edu/translational-teams/"
      } else if(process.env.NODE_ENV === "staging" ) {
        return "https://translationalteams-dev.chs.asu.edu/translational-teams/";
      }
      return "https://translationalteams-local.chs.asu.edu/translational-teams/";
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    reset() {
      this.form.items = this.items;
    },
    save() {
      event.preventDefault();
      this.$emit("save", this.form.items);
      this.showForm = false;
    },
    displayItem(item) {
      return item.name;
    }
  },

  watch: {
    items: function() {
      if (this.items) {
        this.form.items = _.clone(this.items);
      }
    }
  },
  created() {
    if (this.items) {
      this.form.items = _.clone(this.items);
    }
  }
};
</script>

<style scoped>
.form-horizontal {
  font-size: 13px;
}

.award-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

.award-list {
  font-size: 16px;
}
table {
  font-size: 10pt;
}
</style>
